export enum TimePeriod {
    None,
    BeginDate,
    EndDate,
    Both
}

export const TimePeriods = [
    { key: TimePeriod.None, value: 'None' },
    { key: TimePeriod.BeginDate, value: 'Begin date' },
    { key: TimePeriod.EndDate, value: 'End date' },
    { key: TimePeriod.Both, value: 'Both' }
];